import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ImageHideIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M.293.293a1 1 0 011.414 0l11.912 11.91c.032.026.064.054.094.084l.083.094 9.911 9.912a1 1 0 01-1.414 1.414l-2.001-1.999c-.398.19-.838.292-1.292.292H5l-.059-.002h.001L5 22a3 3 0 01-3-3V5.004v.016-.066c-.002-.155-.003-.531.002-.627.014-.278.061-.507.192-.718L.293 1.707a1 1 0 010-1.414zm12.706 14.121L7.414 20h11.171l-5.586-5.586zM4 5.415V19a1 1 0 00.65.937L11.584 13l-2.49-2.49a2.499 2.499 0 01-3.143-3.142L4 5.415zM19 2a3 3 0 013 3v11a1 1 0 01-2 0v-.585l-4.035-4.036a1 1 0 01-1.158-1.6l.486-.486a1 1 0 011.414 0L20 12.585V5a1 1 0 00-1-1H8a1 1 0 110-2h11z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ImageHideIcon.isCarinaIcon = true;
export default ImageHideIcon;
